import React, { memo } from 'react';
import useCustomerData from './Hooks/useCustomerData';
import AlertComponent from '../../components/AlertComponent';
import TermsAndConditionPage from '../TermsAndCondition';
import MainComponent from './Components/main';

const LandingPageComponent = () => {
  const {
    customerData,
    showModal,
    onConfirm,
    onCancel,
    showTerms,
    showWorkingHours,
    setCustomerData,
    updateCustomerData,
    validated,
    handleSubmit,
    errorMsg,
    registrationRequest,
    handleLoginSuccess,
    handleLoginError,
  } = useCustomerData();

  return (
    <div className="pb-1">
      {!showTerms && !showWorkingHours ? (
        <MainComponent
          customerData={customerData}
          setCustomerData={setCustomerData}
          updateCustomerData={updateCustomerData}
          validated={validated}
          handleSubmit={handleSubmit}
          errorMsg={errorMsg}
          registrationRequest={registrationRequest}
          handleLoginError={handleLoginError}
          handleLoginSuccess={handleLoginSuccess}
        />
      ) : null}
      {showModal ? (
        <div>
          <AlertComponent
            onConfirm={onConfirm}
            onCancel={onCancel}
            showCancel={false}
            confirmBtnText="OK"
            msg="You are not authorized as a falcon seller with us. Please get in touch on falcon@arzooo.com to register as a supplier and we will get back to you."
            btn1Style={{
              background: '#22C0E7',
              padding: '0.4rem 1.8rem',
              outline: 'none',
              color: 'white',
              border: 'none',
              borderRadius: '5px',
            }}
          />
        </div>
      ) : null}
      {showTerms || showWorkingHours ? (
        <TermsAndConditionPage showTerms={showTerms} showWorkingHours={showWorkingHours} />
      ) : null}
    </div>
  );
};
export default memo(LandingPageComponent);
